import { INotificationState } from '../../models';

export const notificationState: INotificationState = {
  variant: 'default',
  message: '',
};
